import apiClient from "./axiosInstance";
import apiClientAuth from "./axiosInstanceauth";
// export const fetchUsers = () => {
//   return axiosInstance.get('/users');
// };
import { auth, signOut } from "../pages/ExtraPages/firebaseConfig";

export const registerUser = async (userData) => {
  console.log(userData);
  return await apiClientAuth.post("/create-user", userData);
};

export const isTokenExpired = async () => {
  return await apiClient.get("/is-token-expired");
};

export const logout = async () => {
  await signOut(auth);
  console.log("User signed out");
};
